import NumberBox, {INumberBoxOptions}  from 'devextreme-react/number-box';
import { dxNumberBoxOptions } from "devextreme/ui/number_box";
import { useEffect, useState } from "react";
import { GetNewId } from "shared/utility/CommonUtility";
import {
  Validator,
  RequiredRule,
} from "devextreme-react/validator";
import InputProps from "interfaces/InputProps";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import {
  getSizeSpecificClasses,
  getControlRadius,
} from "shared/utility/ControlUtility";
import "./styles/Controls.css";

export default function PromineoNumberBox(
  props: dxNumberBoxOptions & INumberBoxOptions & InputProps
) {
  const { className: propClassName, controlRef, onValidated, ...rest } = props;
  const { id, label, required, size, radiusSize } = props;
  const [validatorRules, setValidatorRules] = useState<any>([]);
  
  useEffect(() => {
    const setValidationRules = () => {
      const rules = [];
      if (required) {
        const rule = (
          <RequiredRule
            key={`${GetNewId()}-${id}`}
            message={`${label} is required.`}
          />
        );
        rules.push(rule);
      }

      setValidatorRules(rules);
    };

    setValidationRules();
  }, [id, label, required]);

  const getClassNames = () => {
    const classNames = `${getSizeSpecificClasses(
      size
    )} prom-control border-1.5 border-silver outline-none ${getControlRadius(
      radiusSize
    )}`;
    return propClassName ? `${classNames} ${propClassName}` : classNames;
  };

  return (
    <NumberBox {...rest} className={getClassNames()} ref={controlRef}>
      <Validator onValidated={onValidated}>{validatorRules}</Validator>
    </NumberBox>
  );
}

PromineoNumberBox.defaultProps = {
  size: ControlSize.Midium,
  radiusSize: ControlSize.Large,
};
